import { makeStyles } from '@material-ui/core'
import theme from '../theme'

const styleOverride = makeStyles({
  /* Styles applied to the root element. */
  outlinedSuccess: {
    background: theme.palette.success.light,
    boxShadow: 'none',
    border: '1.4px solid #1e8d47',
    marginBottom: '15px',
    '& .MuiAlert-icon': {
      '& svg': {
        marginTop: '3px',
        marginLeft: '2px',
        width: '28px',
        height: '28px',
        transform: 'scale(0.85)',
        '& path': {
          fill: theme.palette.success.light,
          fillOpacity: '1',
          stroke: 'none',
        },
      },
    },
  },
  outlinedInfo: {
    background: theme.palette.info.light,
    boxShadow: 'none',
    border: '1.4px solid #5b73ba',
    marginBottom: '15px',
    '& .MuiAlert-icon': {
      '& svg': {
        marginTop: '3px',
        marginLeft: '2px',
        width: '28px',
        height: '28px',
        stroke: '#5b73ba',
        transform: 'scale(1)',
        '& path': {
          fill: '#5b73ba',
          fillOpacity: '1',
          stroke: 'none',
        },
      },
    },
  },
  outlinedWarning: {
    marginBottom: '15px',
    boxShadow: 'none',
    background: theme.palette.warning.light,
    border: '1.4px solid #fc0',
    '& .MuiAlert-icon': {
      '& svg': {
        width: '28px',
        height: '28px',
        stroke: 'none',
        '& path': {
          fill: '#fc0',
          fillOpacity: '1',
          stroke: theme.palette.warning.light,
        },
        transform: 'scale(1)',
      },
    },
  },
  outlinedError: {
    marginBottom: '15px',
    boxShadow: 'none',
    background: theme.palette.error.light,
    border: '1.4px solid #eb0043',
    '& .MuiAlert-icon': {
      '& svg': {
        marginTop: '3px',
        width: '28px',
        height: '28px',
        marginLeft: '2px',
        '& path': {
          fill: '#eb0043',
          fillOpacity: '1',
          stroke: 'none',
        },
        transform: 'scale(1)',
      },
    },
  },
  message: {
    width: '100%',
    textAlign: 'center',
  },
  root: {
    width: '100%',
    padding: '2px 10px 2px 10px',
    lineHeight: '28px',
  },
  icon: {
    marginRight: '0px',
  },
  closeIcon: {
    '& svg': {
      marginTop: '0px',
      '& path': {
        stroke: 'none',
      },
    },
  },
})

export default styleOverride
